<template>
  <div v-if="isLoading && !isError" class="vcv-billing-tariffs">
    <vpreloader />
  </div>

  <div v-else-if="isLoading && isError" class="vcv-billing-tariffs">
    Ошибка загрузки тарифов. Попробуйте снова или обратитесь к службе поддержки.
  </div>

  <div v-else class="vcv-billing-tariffs">
    <vcv-billing-info />

    <div class="vcv-billing-tariffs__choose">
      <div ref="blocksWrapper" class="vcv-billing-tariffs__blocks-wrapper">
        <div class="vcv-billing-tariffs__blocks">
          <div
            ref="1"
            class="vcv-billing-tariffs__block vcv-billing-tariffs__startup"
            :class="{ active: currentTariff === 1 }"
            @click="changeTariff(1)"
          >
            <div class="vcv-billing-tariffs__block-title">
              {{ getTariffById(1) !== null ? getTariffById(1).name : '' }}
            </div>

            <ul class="vcv-billing-tariffs__block-list">
              <li><i class="icon icon-check"></i>{{ $tr('price.popup.pageCompany') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('vacancy.preferences.settings.application') }}</li>
              <li>
                <i class="icon icon-check"></i>
                {{ $tr('interview.landing.modules.sibur-test.title') }}
              </li>
              <li><i class="icon icon-check"></i>{{ $tr('vacancy.modules.videointerview.title') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('common.marketplace') }}</li>
            </ul>

            <div class="vcv-billing-tariffs__block-price">
              {{ getTariffById(1) !== null ? getTariffById(1).price : 0 }} {{ $tr('billing.currency-per-month') }}
            </div>

            <div class="vcv-billing-tariffs__block-description">
              {{
                $tr('billing.vacancies-and-responses-per-month', {
                  vacancies: 1,
                  responses: getTariffById(1) !== null ? getTariffById(1).monthly_responses : ''
                })
              }}
            </div>
          </div>

          <div
            ref="2"
            class="vcv-billing-tariffs__block vcv-billing-tariffs__business"
            :class="{ active: currentTariff === 2 }"
            @click="changeTariff(2)"
          >
            <div class="vcv-billing-tariffs__block-title">
              {{ getTariffById(2) !== null ? getTariffById(2).name : '' }}
            </div>

            <ul class="vcv-billing-tariffs__block-list">
              <li>
                <i class="icon icon-check"></i>{{ $tr('billing.all-features') }}
                <strong class="capitalize">{{ getTariffById(1) !== null ? getTariffById(1).name : '' }}</strong>
              </li>
              <li><i class="icon icon-check"></i>{{ $tr('billing.cutting-questions') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('billing.chat-bots') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('billing.open-api') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('billing.vacancy-rights') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('common.navigation.log') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('common.navigation.competencies') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('billing.company-documents') }}</li>
            </ul>

            <div class="vcv-billing-tariffs__block-price">
              {{ getTariffById(2) !== null ? getTariffById(2).price : 0 }} {{ $tr('billing.currency-per-month') }}
            </div>

            <div class="vcv-billing-tariffs__block-description">
              {{
                $tr('billing.vacancies-and-responses-per-month', {
                  vacancies: 1,
                  responses: getTariffById(2) !== null ? getTariffById(2).monthly_responses : ''
                })
              }}
            </div>
          </div>

          <div
            ref="3"
            class="vcv-billing-tariffs__block vcv-billing-tariffs__professional"
            :class="{ active: currentTariff === 3 }"
            @click="changeTariff(3)"
          >
            <div class="vcv-billing-tariffs__block-title">
              {{ getTariffById(3) !== null ? getTariffById(3).name : '' }}
            </div>

            <ul class="vcv-billing-tariffs__block-list">
              <li>
                <i class="icon icon-check"></i>{{ $tr('billing.all-features') }}
                <strong class="capitalize">{{ getTariffById(2) !== null ? getTariffById(2).name : '' }}</strong>
              </li>
              <li><i class="icon icon-check"></i>{{ $tr('billing.personal-manager') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('billing.legal-contract') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('billing.speech-recognition') }}</li>
              <li><i class="icon icon-check"></i>{{ $tr('billing.password-policies') }}</li>
              <li><i class="icon icon-check"></i>SSO</li>
              <li><i class="icon icon-check"></i>{{ $tr('pageTitles.routes.analytics') }}</li>
            </ul>

            <div class="vcv-billing-tariffs__block-price">
              {{ getTariffById(3) !== null ? getTariffById(3).price : 0 }} {{ $tr('billing.currency-per-month') }}
            </div>

            <div class="vcv-billing-tariffs__block-description">
              {{
                $tr('billing.vacancies-and-responses-per-month', {
                  vacancies: 1,
                  responses: getTariffById(3) !== null ? getTariffById(3).responses : '' // берем именно reponses потому, что на этом тарифе отклики не сгорают
                })
              }}
              ({{ $tr('billing.charged-for-entire-period') }})
            </div>
          </div>

          <div ref="offer" class="vcv-billing-tariffs__block vcv-billing-tariffs__offer" @click="changeTariff('offer')">
            <div>
              <div class="vcv-billing-tariffs__block-title">
                {{ $tr('billing.want-individual') }}
              </div>

              <div class="vcv-billing-tariffs__block-text">{{ $tr('billing.personal-offer') }}</div>
            </div>

            <vbutton :text="$tr('billing.call-me-back')" block />
          </div>
        </div>
      </div>

      <!-- total -->
      <div class="vcv-billing-tariffs__block vcv-billing-tariffs__summ">
        <div class="vcv-billing-tariffs__summ-left">
          <div class="vcv-billing-tariffs__block-title">{{ $tr('billing.vacancies-count') }}</div>
          <div class="vcv-billing-tariffs__block-text vcv-billing-tariffs__calc mb">
            {{ priceFormat(currentTariffCost) }} {{ $tr('billing.currency-per-month') }}
            <span>x</span>
            <vcv-billing-counter
              :value="vacanciesCount"
              :min-value="1"
              :max-value="30"
              @input="vacanciesCount = $event"
            />
            <span>=</span>
            <span class="vcv-billing-tariffs__calc--green">
              {{ priceFormat(currentTariffCost * vacanciesCount) }}
              {{ $tr('billing.currency-per-month') }}
            </span>
          </div>

          <div class="vcv-billing-tariffs__block-title">
            {{ $tr('billing.additional-options') }}
          </div>
          <div class="vcv-billing-tariffs__block-text vcv-billing-tariffs__calc mb">
            {{ $tr('billing.additional-responses') }}
            <vcv-billing-counter
              :value="additionalResponses"
              :min-value="0"
              :max-value="500"
              :step="10"
              @input="additionalResponses = $event"
            />
          </div>
          <div class="vcv-billing-tariffs__block-text mb">
            {{ $tr('billing.response-time') }}
            <vcv-billing-counter
              :value="archiveMonths"
              :min-value="minArchiveMonths"
              :max-value="12"
              @input="archiveMonths = $event"
            />
            {{ declOfNum(archiveMonths, [$tr('common.1-month'), $tr('common.2-months'), $tr('common.5-months')]) }}
          </div>
          <div class="vcv-billing-tariffs__block-text mb">
            {{ $tr('billing.video-quality') }}
          </div>
          <div class="vcv-billing-tariffs__checkboxes mb">
            <trigger
              v-model="videoQualityHd"
              :text="`HD ${$tr('billing.video')}`"
              :disabled="videoQualityFullhd"
              small
            />

            <trigger v-model="videoQualityFullhd" :text="`FullHD ${$tr('billing.video')}`" small />
          </div>

          <div class="vcv-billing-tariffs__block-title">{{ $tr('billing.payment-methods') }}</div>

          <ul class="vcv-billing-tariffs__payments">
            <li :class="{ active: currentPayment === 'sbp' }" class="disabled">
              <img src="/static/icons/sbp.svg" alt="" />Система быстрых платежей (QR код)
              <i v-if="currentPayment === 'sbp'" class="icon icon-check"></i>
            </li>
            <li :class="{ active: currentPayment === 'card' }" class="disabled">
              <img src="/static/icons/creditcard.svg" alt="" />
              {{ $tr('billing.payment-methods-card') }}
              <i v-if="currentPayment === 'card'" class="icon icon-check"></i>
            </li>
            <li :class="{ active: currentPayment === 'bill-legal' }">
              <img src="/static/icons/bill.svg" alt="" />
              {{ $tr('billing.payment-methods-legal') }}
              <i v-if="currentPayment === 'bill-legal'" class="icon icon-check"></i>
            </li>
            <li :class="{ active: currentPayment === 'bill-individual' }" class="disabled">
              <img src="/static/icons/bill.svg" alt="" />
              {{ $tr('billing.payment-methods-individual') }}
              <i v-if="currentPayment === 'bill-individual'" class="icon icon-check"></i>
            </li>
          </ul>
        </div>

        <div class="vcv-billing-tariffs__summ-right">
          <div class="vcv-billing-tariffs__summ-right-up">
            <div class="vcv-billing-tariffs__block-title">{{ $tr('billing.itogo') }}</div>

            <div class="vcv-billing-tariffs__block-grey">
              {{ $tr('profile.group.rates') }}
              <span class="capitalize">
                {{ getTariffById(currentTariff) !== null ? getTariffById(currentTariff).name : '' }}
              </span>
            </div>

            <div class="vcv-billing-tariffs__block-grey">
              {{ getTariffById(currentTariff) !== null ? getTariffById(currentTariff).price : 0 }}
              {{ $tr('billing.currency-per-month') }}
            </div>

            <div v-if="archiveMonths > 0" class="vcv-billing-tariffs__block-grey">
              x {{ archiveMonths }}
              {{ declOfNum(archiveMonths, [$tr('common.1-month'), $tr('common.2-months'), $tr('common.5-months')]) }}
            </div>

            <div v-if="vacanciesCount > 0" class="vcv-billing-tariffs__block-grey">
              x {{ vacanciesCount }}
              {{
                declOfNum(vacanciesCount, [
                  $tr('common.1-vacancy'),
                  $tr('common.2-vacancies'),
                  $tr('common.5-vacancies')
                ])
              }}
            </div>

            <div class="vcv-billing-tariffs__block-title vcv-billing-tariffs__block-title--right">
              {{ priceFormat(subtotal) }} ₽
            </div>

            <div class="vcv-billing-tariffs__block-line"></div>

            <div class="vcv-billing-tariffs__block-title">
              {{ $tr('billing.additional-options') }}
            </div>
            <div class="vcv-billing-tariffs__block-grey">
              {{ monthlyResponses }}
              <span v-if="additionalResponses > 0">+ {{ additionalResponses }}</span>
              {{
                declOfNum(additionalResponses, [
                  $tr('common.1-response'),
                  $tr('common.2-responses'),
                  $tr('common.5-responses')
                ])
              }}
            </div>
            <div v-if="videoQualityHd || videoQualityFullhd" class="vcv-billing-tariffs__block-grey">
              + {{ videoQualityFullhd ? 'FullHD' : videoQualityHd ? 'HD' : '' }}
              {{ $tr('billing.video') }}
            </div>
            <div class="vcv-billing-tariffs__block-title vcv-billing-tariffs__block-title--right">
              {{ priceFormat(subtotal2) }} ₽
            </div>
          </div>

          <div class="vcv-billing-tariffs__summ-right-down">
            <div class="vcv-billing-tariffs__block-subtotal mb">{{ $tr('billing.cost') }}</div>
            <div class="vcv-billing-tariffs__block-total">{{ priceFormat(total) }} Ꝑ</div>

            <vbutton label="billing.checkout" block />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Trigger from '@/components/shared/Trigger.vue';
import VcvBillingInfo from '@/routes_new/inner/billing/VcvBillingInfo';
import VcvBillingCounter from '@/routes_new/inner/billing/VcvBillingCounter';
import { declOfNum } from '@/_helpers/utils.js';

export default {
  name: 'VcvBillingTariffs',

  components: {
    VcvBillingCounter,
    VcvBillingInfo,
    Trigger
  },

  data() {
    return {
      isLoading: false,
      isError: false,
      currentTariff: 2, // 1 - startup, 2 - business, 3 - professional
      vacanciesCount: 1,
      additionalResponses: 0,
      archiveMonths: 2,
      currentPayment: 'bill-legal', // bill-legal – для юридическийх, bill-individual - для физических, card - кредитная карта, sbp - СБП
      videoQualityHd: false,
      videoQualityFullhd: false
    };
  },

  computed: {
    ...mapState('company_new', ['tariffs']),

    ...mapGetters('company_new', ['getTariffById']),

    currentTariffCost() {
      return this.getTariffById(this.currentTariff) !== null ? this.getTariffById(this.currentTariff).price : 0;
    },

    minArchiveMonths() {
      return this.getTariffById(this.currentTariff) !== null
        ? this.getTariffById(this.currentTariff).response_lifetime
        : 1;
    },

    monthlyResponses() {
      // для professional тарифа берем просто responses так как они не сбрасываются каждый месяц
      if (this.currentTariff === 3) {
        return this.getTariffById(this.currentTariff) !== null ? this.getTariffById(this.currentTariff).responses : 0;
      }

      return this.getTariffById(this.currentTariff) !== null
        ? this.getTariffById(this.currentTariff).monthly_responses
        : 0;
    },

    subtotal() {
      const costPerMonth =
        this.getTariffById(this.currentTariff) !== null
          ? this.getTariffById(this.currentTariff).extra_response_lifetime_price
          : 0;
      // + vacancies
      const vacanciesCost = this.vacanciesCount * this.currentTariffCost;

      // + archiveMonths
      let additionalMonths = 0;

      if (this.currentTariff === 1) {
        additionalMonths = this.archiveMonths - 1 < 0 ? 0 : this.archiveMonths - 1;
      }
      if (this.currentTariff === 2) {
        additionalMonths = this.archiveMonths - 2 < 0 ? 0 : this.archiveMonths - 2;
      }
      if (this.currentTariff === 3) {
        additionalMonths = this.archiveMonths - 3 < 0 ? 0 : this.archiveMonths - 3;
      }

      return vacanciesCost + additionalMonths * costPerMonth;
    },

    subtotal2() {
      // + additionalResponses
      const costPer100Responses =
        this.getTariffById(this.currentTariff) !== null
          ? this.getTariffById(this.currentTariff).extra_responses_price
          : 0;
      const costHdResponsesPrice =
        this.getTariffById(this.currentTariff) !== null ? this.getTariffById(this.currentTariff).hd_responses_price : 0;
      const costFullHdResponsesPrice =
        this.getTariffById(this.currentTariff) !== null
          ? this.getTariffById(this.currentTariff).full_responses_price
          : 0;
      const multiplierResponses = Math.ceil(this.additionalResponses / 100);

      // + VideoQuality
      let videoQualityCost = 0;
      if (this.videoQualityHd) {
        videoQualityCost = multiplierResponses * costHdResponsesPrice;
      }
      if (this.videoQualityFullhd) {
        videoQualityCost = multiplierResponses * costFullHdResponsesPrice;
      }

      return costPer100Responses * multiplierResponses + videoQualityCost;
    },

    total() {
      return this.subtotal + this.subtotal2;
    }
  },

  watch: {
    videoQualityFullhd(value) {
      if (value) {
        this.videoQualityHd = true;
      }
    }
  },

  async created() {
    this.isLoading = true;

    await this.fetchTariffs()
      .catch(() => {
        this.isError = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },

  mounted() {
    this.changeTariff(2);
  },

  methods: {
    declOfNum,

    ...mapActions('company_new', ['fetchTariffs']),

    priceFormat(price) {
      return Intl.NumberFormat('ru-RU').format(price);
    },

    scrollToBlock(tariffName) {
      if (window.innerWidth <= 600) {
        const scrollLeft =
          this.$refs[tariffName].offsetLeft - (window.innerWidth - this.$refs[tariffName].clientWidth) / 2;

        this.$refs.blocksWrapper.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    },

    changeTariff(tariffName) {
      // своеобразный slick слайдер. Скроллит по центру окна выбранный блок для экрана мобильных (< 600)
      if (window.innerWidth <= 600) {
        this.scrollToBlock(tariffName);
      }

      if (tariffName === 'offer') {
        return false;
      }

      this.currentTariff = tariffName;

      if (tariffName === 2) {
        this.archiveMonths = 2;
      }
      if (tariffName === 3) {
        this.archiveMonths = 3;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vcv-billing-tariffs {
  padding: 20px 30px;

  @media screen and (max-width: 1500px) {
    max-width: 560px;
  }

  @media screen and (max-width: 600px) {
    padding: 30px 0 0;
    width: 100%;
    max-width: none;
  }

  .capitalize {
    display: inline-block;

    &::first-letter {
      text-transform: capitalize;
    }
  }

  &__choose {
    min-height: calc(100vh - 64px);
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: 1500px) {
      max-width: 560px;
      flex-direction: column;
    }

    @media screen and (max-width: 600px) {
      ::v-deep .vcv-billing-counter {
        margin: 7px;
      }
    }
  }

  .mb {
    margin-bottom: 15px;
  }

  &__blocks-wrapper {
    @media screen and (max-width: 600px) {
      overflow-x: hidden;
      width: 100%;
    }
  }

  &__blocks {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-right: 20px;
    width: 500px;
    max-height: 640px;
    position: relative;
    z-index: 1;

    @media screen and (max-width: 1500px) {
      margin-right: 0;
      margin-bottom: 20px;
    }

    @media screen and (max-width: 600px) {
      flex-direction: row;
      flex-wrap: nowrap;
      max-height: none;
      width: 1580px;
      justify-content: center;
      margin-bottom: 30px;
    }
  }

  &__startup {
    margin-bottom: 20px;
    margin-right: 20px;
    height: 253px;
    order: 1;

    @media screen and (max-width: 600px) {
      order: 1;
    }
  }

  &__business {
    margin-bottom: 20px;
    height: 340px;
    order: 3;

    @media screen and (max-width: 600px) {
      order: 2;
      margin-right: 20px;
    }
  }

  &__professional {
    height: 360px;
    order: 2;

    @media screen and (max-width: 600px) {
      margin-right: 20px;
      order: 3;
    }
  }

  &__offer {
    height: 274px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    order: 4;
  }

  &__block {
    padding: 20px;
    width: 240px;
    border: 1px solid transparent;
    cursor: pointer;
    position: relative;
    background: #fff;
    transition: border 0.3s;

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
      box-shadow: $box-shadow;
      pointer-events: none;
      transition: box-shadow 0.3s;
    }

    &:hover:before {
      box-shadow: 0px 24px 34px rgba(0, 0, 0, 0.1);
      transition: box-shadow 0.3s;
    }

    &.active {
      border: 1px solid $green;
      transition: border 0.3s;
    }

    @media screen and (max-width: 600px) {
      height: auto;
      width: 300px;
      margin: 0 10px;
    }

    @media screen and (max-width: 450px) {
      width: 260px;
    }

    @media screen and (max-width: 350px) {
      width: 220px;
    }
  }

  &__summ {
    width: 616px;
    height: 634px;
    z-index: 0;
    display: flex;
    justify-content: space-between;
    padding: 0;

    @media screen and (max-width: 1500px) {
      max-width: 500px;
      flex-direction: column;
      margin: 0 auto 50px;
      height: auto;
    }

    @media screen and (max-width: 600px) {
      width: 90%;
      height: auto;
      margin: 0 auto 50px;
    }

    &:hover:before {
      box-shadow: $box-shadow;
    }
  }

  &__summ-left {
    padding: 20px;
    width: 395px;
    border-right: 1px solid $green;

    @media screen and (max-width: 1500px) {
      width: 100%;
      border-right: none;
      border-bottom: 1px solid $green;
    }
  }

  &__summ-right {
    background: #f1f3f6;
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }

  &__block-grey {
    @include mixin-text-tag;
    color: $grey-darker;
    margin-bottom: 5px;
  }

  &__block-total {
    font-size: 24px;
    color: $green;
    margin-top: 10px;
    margin-bottom: 15px;
    text-align: right;
  }

  &__block-subtotal {
    font-size: 14px;
    text-align: right;
  }

  &__payments {
    li {
      padding: 5px 5px 5px 30px !important;
      list-style: none;
      margin-bottom: 10px;
      @include mixin-text-tag;
      font-size: 14px;
      padding-left: 20px;
      position: relative;
      transition: color 0.3s;
      border-left: 1px solid transparent;

      &:hover {
        color: $green-hover;
        transition: color 0.3s;
      }

      img {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
      }

      i {
        margin-left: 5px;
        color: $green;
      }

      &.disabled {
        pointer-events: none;
        color: $grey;
      }

      &.active {
        border-left: 1px solid $green;
      }
    }
  }

  &__block-title {
    @include mixin-text-header;
    margin-bottom: 15px;
    font-size: 16px;

    &::first-letter {
      text-transform: capitalize;
    }

    &--right {
      text-align: right;
      margin-bottom: 10px;
    }
  }

  &__block-list {
    margin-bottom: 15px;

    li {
      list-style: none;
      margin-bottom: 10px;
      @include mixin-text-tag;
      font-size: 14px;
      padding-left: 20px;
      position: relative;

      i {
        color: $green;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
  }

  &__block-text {
    @include mixin-text-tag;
    font-size: 14px;
  }

  &__calc {
    align-items: center;
    display: flex;

    span {
      display: inline-block;
      margin: 0 10px;
    }

    &--green {
      color: $green;
      margin: 0 !important;
    }
  }

  &__block-price {
    @include mixin-text-header-big;
    font-size: 18px;
    margin-bottom: 3px;
  }

  &__block-line {
    width: 100%;
    background: $grey-light;
    height: 1px;
    margin: 20px 0;
  }

  &__block-description {
    color: $grey !important;
    @include mixin-text-tag;
    font-size: 10px;
  }

  &__checkboxes {
    > * {
      margin-bottom: 10px;
    }

    ::v-deep .trigger__text {
      color: $main-dark;
    }
  }
}
</style>
